//
// DataAnimation.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./DataRendererModel";
import "../data/ClassificationRole";
import "./SortOrder";
import "./DataAnimationKeyframePosition";
import "./controller/DataAnimationController";

var DataAnimation = createModule("gtl::DataAnimation", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::RendererModel","gtl::DataRendererModel"], EventDispatcher, [
    ,
    {
        initialKeyframe: 4,
        repeatEnabled: 2,
        playDirectionForward: 2,
        masterDataAnimation: 1,
        sortOrder: 4,
        keyframesPerSecond: 6,
        slaveKeyframeOffset: 3,
        keyframe: 1,
        displayKeyframeValue: 2,
    },
    ,
    ,
    {
        getController: [1],
    },
    {
        _create: [4],
    },
    ,
]);
export default DataAnimation;
